import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import goodJobSvg from '../images/goodJob.svg';
import TextField from '@material-ui/core/TextField';
import Transition from './Dialogs/Transition';

const styles = {
	goodJobIcon: {
		display: 'inline-block',
		width: 50,
		height: 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	label: {},
	value: {
		fontWeight: 600,
	},
	current: {},
	new: {
		marginTop: 20,
	},
};

export default class ConwayDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newConwayValue: '',
		};

		this.handleRequestClose = this.handleRequestClose.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	handleRequestClose() {
		this.props.onClose();
	}

	handleUpdate() {
		const params = {};
		params.fieldName = 'opis.conway.inputted.naturalGas.avg';
		params.fieldValue = this.state.newConwayValue;

		this.props.addDataRecord({
			params,
			callback: function (err) {
				if (!err) {
					this.props.onClose();
				}
			}.bind(this),
		});
	}

	onChange(event, fieldName) {
		this.setState({ [fieldName]: event.target.value });
	}

	render() {
		return (
			<Dialog
				open={this.props.open}
				TransitionComponent={Transition}
				maxWidth="md"
				onClose={this.handleRequestClose}
			>
				<div style={{ padding: '20px 40px', width: '400px' }}>
					<DialogTitle>Update Conway Data</DialogTitle>
					<DialogContent>
						<div style={styles.current}>
							<span style={styles.label}>Current Conway Natural Gas Cost: </span>
							<span style={styles.value}>{this.props.currentConwayValue}</span>
						</div>

						<TextField
							style={styles.new}
							value={this.state.newConwayValue}
							onChange={(event) => this.onChange(event, 'newConwayValue')}
							label="New Conway Natural Gas Cost (avg)"
							fullWidth
						/>

						<DialogContentText></DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose}>Cancel</Button>
						<Button variant="contained" onClick={this.handleUpdate} color="primary">
							Update
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

ConwayDialog.propTypes = {
	open: PropTypes.bool,
	addDataRecord: PropTypes.func.isRequired,
	currentConwayValue: PropTypes.string,
	onClose: PropTypes.func.isRequired,
};
